module.exports = __webpack_public_path__ + "img/logo-hor.1f4f7ddf.png";